/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".icon-display[_ngcontent-%COMP%]{transform:scale(1.2)}@media screen and (max-width:320px){.alert-display[_ngcontent-%COMP%]{width:-webkit-fit-content!important;width:-moz-fit-content!important;width:fit-content!important}}"];
export { styles as styles };
